define("calendar/components/calendar/settings/bttp", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "ember-concurrency-decorators", "ember-concurrency-ts", "moment", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _object, _service, _emberConcurrencyDecorators, _emberConcurrencyTs, _moment, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.getBttpInclusionDates = getBttpInclusionDates;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"ember-concurrency-decorators",0,"ember-concurrency-ts",0,"moment",0,"later/utils/constants",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <hr class="u--m__b__0" {{did-insert this.handleBttpError}}>
  <div class="u--row at--bttpChecklist__SettingsBttp">
    <div class="u--col__4 u--m__t__md">
      <h5 class="u--text--md u--m__t__0" data-test-id="calendar-settings-bttp-title">
        {{#if this.isTiktok}}
          {{t "bttp.tiktok.title"}}
          <Shared::Badge @className="cBL--badge--sm" />
        {{else}}
          {{t "bttp.title"}}
        {{/if}}
      </h5>
    </div>
  
    <div class="u--col__8 u--m__t__md at--bttpRetention__bttpSection">
      {{#if (not this.canBttp)}}
        <Calendar::Settings::Bttp::Enable
          @isOnLegacyPlan={{this.isOnLegacyPlan}}
          @upgradeButtonText={{this.upgradeButtonText}}
        />
      {{else if this.notEnoughFollowers}}
        <Calendar::Settings::Bttp::Followers
          @numberOfFollowers={{this.numberOfFollowers}}
          @requiredFollowers={{this.requiredFollowers}}
          @nickname={{this.socialProfile.displayNickname}}
          @profileType={{this.socialProfile.capitalizedProfileType}}
          @isOnLegacyPlan={{this.isOnLegacyPlan}}
        />
      {{else if (or this.needsProfessional this.needsProfessionalToken)}}
        <Calendar::Settings::Bttp::BusinessAccount
          @needsProfessional={{this.needsProfessional}}
          @immediateBttpRolloutFlagEnabled={{this.immediateBttpRolloutFlagEnabled}}
          @isOnLegacyPlan={{this.isOnLegacyPlan}}
          @singleSocialProfile={{this.socialProfile}}
          @upgradeButtonText={{this.upgradeButtonText}}
        />
      {{else if (and this.isLegacyBttp this.immediateBttpEnabled)}}
        <Calendar::Settings::Bttp::Upgrade @triggerBttp={{this.triggerBttp}} />
      {{else if this.bttpHasError}}
        <Calendar::Settings::Bttp::Error
          @bttpInclusionDateText={{this.bttpInclusionDateText}}
          @bttpReport={{@bttpReport}}
          @isLegacyBttp={{this.isLegacyBttp}}
          @isOnLegacyPlan={{this.isOnLegacyPlan}}
          @postPercentageCSS={{this.postPercentageCSS}}
          @singleSocialProfile={{this.socialProfile}}
        />
      {{else if this.hasBttpReportData}}
        <Calendar::Settings::Bttp::Report
          @bttpLastCalculatedText={{this.bttpLastCalculatedText}}
          @immediateBttpEnabled={{this.immediateBttpEnabled}}
          @immediateBttpRolloutFlagEnabled={{this.immediateBttpRolloutFlagEnabled}}
          @isLegacyBttp={{this.isLegacyBttp}}
          @isOnLegacyPlan={{this.isOnLegacyPlan}}
          @numOfBttpTimeSlots={{this.numOfBttpTimeSlots}}
          @bttpToggledOn={{@bttpToggledOn}}
          @singleSocialProfile={{this.socialProfile}}
          @toggleBttp={{@toggleBttp}}
          @triggerBttp={{this.triggerBttp}}
        />
      {{else if this.bttpDataExists}}
        <p class="u--text--bold" data-test-id="bttp-fetching-report">
          {{t "bttp.fetching_report"}}
        </p>
      {{else}}
        <Calendar::Settings::Bttp::Generate @isOnLegacyPlan={{this.isOnLegacyPlan}} @triggerBttp={{this.triggerBttp}} />
      {{/if}}
    </div>
  </div>
  
  */
  {
    "id": "AF+PSYaD",
    "block": "[[[11,\"hr\"],[24,0,\"u--m__b__0\"],[4,[38,0],[[30,0,[\"handleBttpError\"]]],null],[12],[13],[1,\"\\n\"],[10,0],[14,0,\"u--row at--bttpChecklist__SettingsBttp\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__4 u--m__t__md\"],[12],[1,\"\\n    \"],[10,\"h5\"],[14,0,\"u--text--md u--m__t__0\"],[14,\"data-test-id\",\"calendar-settings-bttp-title\"],[12],[1,\"\\n\"],[41,[30,0,[\"isTiktok\"]],[[[1,\"        \"],[1,[28,[35,2],[\"bttp.tiktok.title\"],null]],[1,\"\\n        \"],[8,[39,3],null,[[\"@className\"],[\"cBL--badge--sm\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,2],[\"bttp.title\"],null]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"u--col__8 u--m__t__md at--bttpRetention__bttpSection\"],[12],[1,\"\\n\"],[41,[28,[37,4],[[30,0,[\"canBttp\"]]],null],[[[1,\"      \"],[8,[39,5],null,[[\"@isOnLegacyPlan\",\"@upgradeButtonText\"],[[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"upgradeButtonText\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"notEnoughFollowers\"]],[[[1,\"      \"],[8,[39,6],null,[[\"@numberOfFollowers\",\"@requiredFollowers\",\"@nickname\",\"@profileType\",\"@isOnLegacyPlan\"],[[30,0,[\"numberOfFollowers\"]],[30,0,[\"requiredFollowers\"]],[30,0,[\"socialProfile\",\"displayNickname\"]],[30,0,[\"socialProfile\",\"capitalizedProfileType\"]],[30,0,[\"isOnLegacyPlan\"]]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,7],[[30,0,[\"needsProfessional\"]],[30,0,[\"needsProfessionalToken\"]]],null],[[[1,\"      \"],[8,[39,8],null,[[\"@needsProfessional\",\"@immediateBttpRolloutFlagEnabled\",\"@isOnLegacyPlan\",\"@singleSocialProfile\",\"@upgradeButtonText\"],[[30,0,[\"needsProfessional\"]],[30,0,[\"immediateBttpRolloutFlagEnabled\"]],[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"socialProfile\"]],[30,0,[\"upgradeButtonText\"]]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,9],[[30,0,[\"isLegacyBttp\"]],[30,0,[\"immediateBttpEnabled\"]]],null],[[[1,\"      \"],[8,[39,10],null,[[\"@triggerBttp\"],[[30,0,[\"triggerBttp\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"bttpHasError\"]],[[[1,\"      \"],[8,[39,11],null,[[\"@bttpInclusionDateText\",\"@bttpReport\",\"@isLegacyBttp\",\"@isOnLegacyPlan\",\"@postPercentageCSS\",\"@singleSocialProfile\"],[[30,0,[\"bttpInclusionDateText\"]],[30,1],[30,0,[\"isLegacyBttp\"]],[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"postPercentageCSS\"]],[30,0,[\"socialProfile\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"hasBttpReportData\"]],[[[1,\"      \"],[8,[39,12],null,[[\"@bttpLastCalculatedText\",\"@immediateBttpEnabled\",\"@immediateBttpRolloutFlagEnabled\",\"@isLegacyBttp\",\"@isOnLegacyPlan\",\"@numOfBttpTimeSlots\",\"@bttpToggledOn\",\"@singleSocialProfile\",\"@toggleBttp\",\"@triggerBttp\"],[[30,0,[\"bttpLastCalculatedText\"]],[30,0,[\"immediateBttpEnabled\"]],[30,0,[\"immediateBttpRolloutFlagEnabled\"]],[30,0,[\"isLegacyBttp\"]],[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"numOfBttpTimeSlots\"]],[30,2],[30,0,[\"socialProfile\"]],[30,3],[30,0,[\"triggerBttp\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"bttpDataExists\"]],[[[1,\"      \"],[10,2],[14,0,\"u--text--bold\"],[14,\"data-test-id\",\"bttp-fetching-report\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"bttp.fetching_report\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,13],null,[[\"@isOnLegacyPlan\",\"@triggerBttp\"],[[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"triggerBttp\"]]]],null],[1,\"\\n    \"]],[]]]],[]]]],[]]]],[]]]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@bttpReport\",\"@bttpToggledOn\",\"@toggleBttp\"],false,[\"did-insert\",\"if\",\"t\",\"shared/badge\",\"not\",\"calendar/settings/bttp/enable\",\"calendar/settings/bttp/followers\",\"or\",\"calendar/settings/bttp/business-account\",\"and\",\"calendar/settings/bttp/upgrade\",\"calendar/settings/bttp/error\",\"calendar/settings/bttp/report\",\"calendar/settings/bttp/generate\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp.hbs",
    "isStrictMode": false
  });

  function getBttpInclusionDates(startDate) {
    if (!_moment.default.isMoment(startDate)) return;
    const sixMonthsAgo = (0, _moment.default)(startDate).subtract(6, 'months');
    const twoWeeksAgo = (0, _moment.default)(startDate).subtract(2, 'weeks');
    return {
      sixMonthsAgo,
      twoWeeksAgo
    };
  }

  let BttpComponent = (_class = class BttpComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "bttp", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor6, this);

      _initializerDefineProperty(this, "errors", _descriptor7, this);

      _defineProperty(this, "bttpInclusionDates", getBttpInclusionDates((0, _moment.default)()));

      _defineProperty(this, "dateFormat", 'MMMM D, YYYY');
    }

    get account() {
      return this.auth.currentAccount;
    }

    get bttpDataExists() {
      var _this$args$bttpReport;

      return (_this$args$bttpReport = this.args.bttpReport) === null || _this$args$bttpReport === void 0 ? void 0 : _this$args$bttpReport.data;
    }

    get bttpHasError() {
      if (this.bttpDataExists) {
        return this.args.bttpReport.reportErrorText;
      }

      return false;
    }

    get bttpInclusionDateText() {
      if (!this.bttpInclusionDates) {
        return this.errors.log('Missing bttp inclusion dates.', {
          bttpInclusionDates: this.bttpInclusionDates
        });
      }

      const {
        sixMonthsAgo,
        twoWeeksAgo
      } = this.bttpInclusionDates;
      return this.intl.t('bttp.from_date_range', {
        six_months_ago: sixMonthsAgo.format(this.dateFormat),
        two_weeks_ago: twoWeeksAgo.format(this.dateFormat)
      });
    }

    get bttpLastCalculatedText() {
      if (!this.bttpInclusionDates) {
        return this.errors.log('Missing bttp inclusion dates.', {
          bttpInclusionDates: this.bttpInclusionDates
        });
      }

      const {
        sixMonthsAgo,
        twoWeeksAgo
      } = this.bttpInclusionDates;

      const bttpAnalyticsTimestamp = _moment.default.unix(this.args.bttpReport.timestamp);

      return this.intl.t('bttp.last_calculated', {
        date: bttpAnalyticsTimestamp.format(this.dateFormat),
        six_months_ago: sixMonthsAgo.format(this.dateFormat),
        two_weeks_ago: twoWeeksAgo.format(this.dateFormat)
      });
    }

    get canBttp() {
      return this.bttp.canBttp;
    }

    get hasBttpReportData() {
      var _this$args$bttpReport2, _this$args$bttpReport3;

      return this.canBttp && Boolean((_this$args$bttpReport2 = this.args.bttpReport) === null || _this$args$bttpReport2 === void 0 ? void 0 : (_this$args$bttpReport3 = _this$args$bttpReport2.data) === null || _this$args$bttpReport3 === void 0 ? void 0 : _this$args$bttpReport3.bttp_data);
    }

    get immediateBttpEnabled() {
      const accountPermitted = this.account.rolloutImmediateBttpExisting;
      return accountPermitted && this.validFollowerCount && !this.isOnLegacyPlan;
    }

    get immediateBttpRolloutFlagEnabled() {
      return this.account.rolloutImmediateBttpExisting;
    }

    get isOnLegacyPlan() {
      return this.account.isOnLegacyPlan;
    }

    get isLegacyBttp() {
      var _this$args$bttpReport4;

      return ((_this$args$bttpReport4 = this.args.bttpReport) === null || _this$args$bttpReport4 === void 0 ? void 0 : _this$args$bttpReport4.version) === _constants.BTTP_VERSIONS.LEGACY;
    }

    get needsProfessional() {
      return !this.socialProfile.isProfessional;
    }

    get needsProfessionalToken() {
      return this.socialProfile.needsProfessionalTokenRefresh || this.socialProfile.hasUnconnectedProfessional;
    }

    get numOfBttpTimeSlots() {
      return this.args.bttpReport.timeSlots.length;
    }

    get postPercentageCSS() {
      return this.args.bttpReport.numOfPosts ? "width: ".concat(this.args.bttpReport.numOfPosts / this.args.bttpReport.requiredBttpPostData * 100, "%") : 'width: 0%';
    }

    get socialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }

    get upgradeButtonText() {
      if (!this.canBttp) return this.intl.t('shared_phrases.upgrade_plan');
      if (this.needsProfessional) return this.intl.t('bttp.business_required_button');
      if (this.needsProfessionalToken) return this.isTiktok ? this.intl.t('bttp.tiktok.connect_business_button') : this.intl.t('bttp.connect_business_button');
      return '';
    }

    get isTiktok() {
      var _this$socialProfile;

      return (_this$socialProfile = this.socialProfile) === null || _this$socialProfile === void 0 ? void 0 : _this$socialProfile.isTiktok;
    }

    get numberOfFollowers() {
      var _this$socialProfile$f, _this$socialProfile2;

      return (_this$socialProfile$f = (_this$socialProfile2 = this.socialProfile) === null || _this$socialProfile2 === void 0 ? void 0 : _this$socialProfile2.followedBy) !== null && _this$socialProfile$f !== void 0 ? _this$socialProfile$f : 0;
    }

    get requiredFollowers() {
      return this.bttp.requiredFollowerCount;
    }

    get validFollowerCount() {
      return this.numberOfFollowers >= this.requiredFollowers;
    }

    get notEnoughFollowers() {
      return this.isTiktok && !this.validFollowerCount;
    }

    *triggerBttp(refreshBttp) {
      try {
        const response = yield (0, _emberConcurrencyTs.taskFor)(this.bttp.generateBttpReport).perform();

        if (!refreshBttp) {
          return;
        }

        if (response.errors) {
          this.alerts.warning(response.errors);
        } else {
          this.alerts.success(this.intl.t('bttp.success'));
        }

        this.args.closeModal();
        this.segment.track('refreshed-bttp', {
          social_profile: this.socialProfile.id
        });
      } catch (error) {
        this.alerts.warning(error);
      }
    }

    handleBttpError() {
      if (this.bttpHasError) {
        (0, _emberConcurrencyTs.taskFor)(this.triggerBttp).perform(false);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "triggerBttp", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "triggerBttp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleBttpError", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleBttpError"), _class.prototype)), _class);
  _exports.default = BttpComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BttpComponent);
});